import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey } from '../../query/types';

const reportKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'reports'] as const,
    export: [...keys, 'reports', 'export'] as const,
    newMembers: [...keys, 'reports', 'newMembers'] as const,
    newMembersExport: [...keys, 'reports', 'newMembersExport'] as const,
    national: [...keys, 'reports', 'national'] as const,
    nationalExport: [...keys, 'reports', 'nationalExport'] as const,
    officers: [...keys, 'reports', 'officers'] as const,
    officersExport: [...keys, 'reports', 'officersExport'] as const,
  });

export { reportKeys };
